import React from "react";

import CenteredMessage from "@common/components/CenteredMessage/CenteredMessage";
import { getIntegrationTypeName } from "@common/models/integrations";

import WorkspaceJoinElement from "../components/WorkspaceSelectElement";
import { useIntegrationActivationConsumer } from "../consumers/useIntegrationActivationConsumer";

export const IntegrationActivationView = () => {
  const { invalid, loading, setLoading, integrationType, error } = useIntegrationActivationConsumer();

  const message = () => {
    if (loading || invalid) {
      return loading ? "Loading..." : error;
    }
  };

  const showMessage = loading || invalid;

  return (
    <>
      {showMessage ? (
        <CenteredMessage
          title={`Integrating ${getIntegrationTypeName(integrationType)}`}
          paragraph={message()}
          isError={invalid}
        />
      ) : (
        <WorkspaceJoinElement setLoading={setLoading} />
      )}
    </>
  );
};
